import { createSlice } from '@reduxjs/toolkit';
import { OrdersGridStateType } from 'src/types/ordersGrid';

const initialState: OrdersGridStateType = {
    data: null,
    loading: false,
    error: false,
};
export const overviewOverviewOrdersGridSlice = createSlice({
    name: 'overviewOverviewOrdersGrid',
    initialState,
    reducers: {
        getOverviewOrdersGridFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getOverviewOrdersGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getOverviewOrdersGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getOverviewOrdersGridFetch,
    getOverviewOrdersGridFetchSuccess,
    getOverviewOrdersGridFetchFailure,
} = overviewOverviewOrdersGridSlice.actions;

export default overviewOverviewOrdersGridSlice.reducer;
